// AI工具翻译

export const tools = {
    weddingPhoto: {
      title: 'Wedding Photo',
      description: 'Create romantic wedding photos with style options',
      features: ['Multiple Uploads', 'Style Selection', 'Optional Prompt'],
      ui: {
        uploadTitle: 'Upload Photos',
        uploadDescription: 'Support up to {max} images, preview and remove',
        promptTitle: 'Additional Prompt (Optional)',
        promptDescription: 'Describe scene, clothing, atmosphere and details',
        promptPlaceholder: 'e.g., Outdoor ceremony, soft lighting, elegant composition',
        styleLabel: 'Wedding Style',
        styles: {
          chinese: 'Chinese Wedding',
          western: 'Western Wedding'
        }
      }
    },
    emojiPack: {
      title: 'Emoji Pack Generator',
      description: 'Upload one photo to generate a cohesive emoji sticker pack',
      features: ['Image Upload', 'Size Selection', 'Supplementary Prompt', 'Multi-image Generation']
    },
    groupPhoto: {
      title: 'Group Photo',
      description: 'Compose high-quality group photos from multiple uploads',
      features: ['Multiple Uploads', 'Group Composition', 'Optional Prompt'],
      ui: {
        uploadTitle: 'Upload Group Photos',
        uploadDescription: 'Support up to {max} images, preview and remove',
        promptTitle: 'Additional Prompt (Optional)',
        promptDescription: 'Describe location, atmosphere, and arrangement',
        promptPlaceholder: 'e.g., Office team photo, professional lighting, natural poses'
      }
    },
    popArtPortrait: {
      title: 'Pop Art Portrait',
      description: 'Transform ordinary photos into vibrant pop art style',
      features: ['Vibrant Colors', 'Artistic Style', 'Personalized']
    },
    animeStyle: {
      title: 'Anime Style Conversion',
      description: 'Convert real photos into beautiful anime-style illustrations',
      features: ['Anime Effects', '2D World', 'Illustration Style']
    },
    oilPainting: {
      title: 'Oil Painting Style',
      description: 'Simulate traditional oil painting techniques to create classic artworks',
      features: ['Oil Paint Texture', 'Artistic Style', 'Classic Aesthetics']
    },
    watercolor: {
      title: 'Watercolor Style',
      description: 'Create soft and transparent watercolor artistic effects',
      features: ['Watercolor Effects', 'Soft Tones', 'Artistic Feel']
    },
    sketchStyle: {
      title: 'Sketch Style',
      description: 'Convert to fine pencil sketches or charcoal drawings',
      features: ['Sketch Effects', 'Line Art', 'Black & White Processing']
    },
    cyberpunk: {
      title: 'Cyberpunk Style',
      description: 'Create futuristic cyberpunk artistic style',
      features: ['Tech Feel', 'Neon Effects', 'Futuristic Style']
    },
    faceSwap: {
      title: 'AI Face Pinch',
      description: 'Intelligent face customization and avatar generation',
      features: ['Face Pinch', 'Multiple Styles', 'Avatar Generation']
    },
    professionalPortrait: {
      title: 'Professional Portrait',
      description: 'Transform photos into professional business portraits',
      features: ['Business Style', 'Professional Lighting', 'Corporate Ready']
    },
    photoRestoration: {
      title: 'Photo Restoration',
      description: 'Restore old, damaged or faded photos, remove scratches, stains and imperfections',
      features: ['Old Photo Repair', 'Remove Defects', 'Color Recovery']
    },
    imageUpscaler: {
      title: 'Image Upscaler',
      description: 'Enhance image resolution and quality using AI technology',
      features: ['AI Enhancement', 'High Resolution', 'Quality Improvement']
    },
    imageMatting: {
      title: 'Image Matting',
      description: 'Remove background from images automatically',
      features: ['Auto Background Removal', 'High Precision', 'Transparent Background'],
      ui: {
        uploadTitle: 'Upload Image',
        uploadDescription: 'Support JPG, PNG formats',
        downloadTitle: 'Download Result',
        downloadDescription: 'Download image with transparent background'
      }
    },
    worldView: {
      title: 'World View',
      description: 'Pick a spot on Google Maps and get live weather and location info',
      features: ['Google Maps', 'Live Weather', 'Photo Composition'],
      ui: {
        uploadTitle: 'Upload Photos',
        uploadDescription: 'Support multiple images, preview and remove',
        promptTitle: 'Prompt',
        promptDescription: 'Describe scene, clothing, atmosphere, and details',
        promptPlaceholder: 'e.g., Morning at the seaside, photorealistic, preserve clothing and identity, realistic lighting'
      },
      mapCard: {
        title: 'Map Info',
        description: 'Pick location from map and fill info into card',
        location: 'Location',
        coords: 'Coordinates',
        weather: 'Weather',
        notSelected: 'Not selected',
        loading: 'Loading…',
        openMapButton: 'Choose Location',
        searchPlaceholder: 'Search places',
        confirmButton: 'Use this location',
        selectedPoint: 'Selected:',
        resolving: 'Resolving…'
      }
    }
  };
